import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { IResponseBody } from 'src/app/interfaces/response-body';
import { CommonFunctionService } from 'src/app/services/common-function.service';
import { ApiService } from '../../../app/services/api.service';
@Injectable()
export class CohortsApiService {
  constructor(
    private Api: ApiService,
    private dialog: MatDialog,
    protected commonFunctionService: CommonFunctionService
  ) {}

  public getAllCohorts(role: string, id: number, type: string) {
    let endpoint = `${role}/cohorts?id=${id}&type=${type}`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.get(endpoint, url).then(
      (Cohorts) => Cohorts,
      (error) => this.Api.handleError(error)
    );
  }


  public save(role: string, id, type, Cohorts) {
    const endpoint = `${role}/cohorts?id=${id}&type=${type}`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.post(endpoint, Cohorts, url).then(
      (response: IResponseBody) => response,
      (error) => this.Api.handleError(error)
    );
  }
}
